export function createFukushizaiCopyPreviewService(deps) {
    // 複写 preview 用の detail 113 行を組み立てます。
    function buildFukushizaiCopyPreviewRows(targetItem, targetGroup, sourceItem, sourceGroup) {
        const resolvedTargetItem = deps.normalizeItemCd(targetItem);
        const resolvedTargetGroup = deps.normalizeGroupNo(targetGroup);
        const resolvedSourceItem = deps.normalizeItemCd(sourceItem);
        const resolvedSourceGroup = deps.normalizeGroupNo(sourceGroup);

        // item/group が揃わない場合は preview を作りません。
        if (resolvedTargetItem === "" || resolvedTargetGroup === "" || resolvedSourceItem === "" || resolvedSourceGroup === "") {
            return [];
        }

        const targetColors = deps.getFukushizaiCopyTargetColorCodes();
        const resolvedTargetColors = targetColors(resolvedTargetItem, resolvedTargetGroup);
        if (resolvedTargetColors.length === 0) return [];

        const rowsForCopy = deps.sourceRowsForCopy();
        const sourceRows = rowsForCopy(deps.FUKUSHIZAI_BASE_PANEL_TYPE, resolvedSourceItem, resolvedSourceGroup);
        const sourceRow = sourceRows.find((row) => !deps.isEmpty(row));
        if (deps.isEmpty(sourceRow)) return [];

        const contentColumnIds = deps.getFukushizaiBaseCopyContentColumnIds()();
        return resolvedTargetColors.map((colorCd, index) => {
            const targetRow = deps.createFukushizaiGroupDetailRow()(resolvedTargetItem, resolvedTargetGroup, colorCd, null, false);
            const previewRow = deps.copyFukushizaiContentColumns()(targetRow, sourceRow, contentColumnIds, deps.FUKUSHIZAI_BASE_PANEL_TYPE);
            previewRow[deps.ROW_ID_FIELD] = `preview_${index}`;
            deps.setRowContextForPanel()(previewRow, deps.FUKUSHIZAI_BASE_PANEL_TYPE, resolvedTargetItem, resolvedTargetGroup, colorCd);
            previewRow.__fukushizaiCopyPreview = true;
            previewRow.__fukushizaiCopyPreviewTargetItem = resolvedTargetItem;
            previewRow.__fukushizaiCopyPreviewTargetGroup = resolvedTargetGroup;
            previewRow.__fukushizaiCopyPreviewSourceItem = resolvedSourceItem;
            previewRow.__fukushizaiCopyPreviewSourceGroup = resolvedSourceGroup;
            return previewRow;
        });
    }

    // 現在 context に対して preview が有効かを判定します。
    function isActiveFukushizaiCopyPreview(previewOverride = undefined, context = deps.getSelectedFukushizaiContext()) {
        const preview = previewOverride === undefined ? deps.getPendingFukushizaiCopy() : previewOverride;
        if (deps.isEmpty(preview)) return false;

        const resolvedContext = deps.normalizeFukushizaiContext(context);
        const previewRows = Array.isArray(deps.DicVal(preview, "previewRows", []))
            ? deps.DicVal(preview, "previewRows", [])
            : [];

        return deps.normalizeKakousijiUiString(deps.DicVal(preview, "targetItem", "")) === resolvedContext.itemCd
            && deps.normalizeGroupNo(deps.DicVal(preview, "targetGroup", "")) === resolvedContext.groupNo
            && previewRows.length !== 0;
    }

    // 現在有効な preview 行だけを返します。
    function getActiveFukushizaiCopyPreviewRows(previewOverride = undefined, context = deps.getSelectedFukushizaiContext()) {
        const preview = previewOverride === undefined ? deps.getPendingFukushizaiCopy() : previewOverride;
        if (!isActiveFukushizaiCopyPreview(preview, context)) return [];
        const rows = deps.DicVal(preview, "previewRows", []);
        return Array.isArray(rows) ? rows : [];
    }

    // BASE パネル表示用に preview 行から entrydata を組み立てます。
    function buildFukushizaiPreviewEntryDataForBase(previewOverride = undefined) {
        const previewRows = getActiveFukushizaiCopyPreviewRows(previewOverride, deps.getSelectedFukushizaiContext());
        if (previewRows.length === 0) return deps.getEntryData();

        const next = deps.DeepCopy(deps.getEntryData() || {});
        const previewRow = previewRows[0];
        deps.clearFukushizaiMergedFields()(next);

        deps.getFukushizaiAllFieldIds().forEach((fieldId) => {
            if (Object.prototype.hasOwnProperty.call(previewRow, fieldId)) {
                next[fieldId] = previewRow[fieldId];
            }
            ["nm", "NM", "cd", "CD"].forEach((suffix) => {
                const key = `${fieldId}_${suffix}`;
                if (Object.prototype.hasOwnProperty.call(previewRow, key)) {
                    next[key] = previewRow[key];
                }
            });
        });

        deps.getFukushizaiContextFieldIds().forEach((fieldId) => {
            if (Object.prototype.hasOwnProperty.call(previewRow, fieldId)) {
                next[fieldId] = previewRow[fieldId];
            }
        });

        return next;
    }

    return {
        buildFukushizaiCopyPreviewRows,
        isActiveFukushizaiCopyPreview,
        getActiveFukushizaiCopyPreviewRows,
        buildFukushizaiPreviewEntryDataForBase
    };
}
